import {Invoice} from './_models'

export const resolveInvoiceThreeWayMatchLabel = (invoice: Partial<Invoice>): string => {
  if (invoice.threeWayMatchStatus === 'MATCHED') return 'Matched'
  if (invoice.threeWayMatchStatus === 'PARTIALLY_MATCHED') return 'Partially Matched'
  if (invoice.threeWayMatchStatus === 'NOT_MATCHED') return 'Not Matched'
  if (invoice.threeWayMatchLabel) return invoice.threeWayMatchLabel
  return invoice.threeWayMatched ? 'Matched' : 'Not Matched'
}

export const buildInvoiceThreeWayMatchAmounts = (
  invoice: Partial<Invoice>,
  currency: string
): Array<{label: string; value: string}> => {
  const rows: Array<{label: string; value: string}> = []
  const pushMoney = (label: string, value?: number | null) => {
    if (value == null || Number.isNaN(Number(value))) return
    rows.push({label, value: `${currency} ${Number(value).toFixed(2)}`})
  }

  pushMoney('This Invoice Amount', invoice.invoiceTotalAmount ?? invoice.amount)
  pushMoney('PO Aggregate Invoiced Amount', invoice.aggregatedInvoiceAmount)
  pushMoney('PO Total Amount', invoice.poTotalAmount)
  return rows
}
